import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=4455bf0d&"
import script from "./FilePreview.vue?vue&type=script&lang=js&"
export * from "./FilePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports